import React from 'react';
import './index.scss';

function Timeline(props) {
    return (
        <div class="container my-5">
            <div class="row align-items-center how-it-works d-flex">
                <div class="col-2 text-center bottom d-inline-flex justify-content-center align-items-center">
                    <div class="circle font-weight-bold">1</div>
                </div>
                <div class="col-8">
                    <h5>{props.data.tgl_1}</h5>
                    <p>{props.data.judul_1}</p>
                </div>
            </div>
            <div class="row timeline">
                <div class="col-2">
                    <div class="corner top-right"></div>
                </div>
                <div class="col-8">
                    <hr/>
                </div>
                <div class="col-2">
                    <div class="corner left-bottom"></div>
                </div>
            </div>

            <div class="row align-items-center justify-content-end how-it-works d-flex">
                <div class="col-8 text-right">
                    <h5>{props.data.tgl_2}</h5>
                    <p>{props.data.judul_2}</p>
                </div>
                <div class="col-2 text-center full-right d-inline-flex justify-content-center align-items-center">
                    <div class="circle font-weight-bold">2</div>
                </div>
            </div>
            <div class="row timeline">
                <div class="col-2">
                    <div class="corner right-bottom"></div>
                </div>
                <div class="col-8">
                    <hr/>
                </div>
                <div class="col-2">
                    <div class="corner top-left"></div>
                </div>
            </div>

            <div class="row align-items-center how-it-works d-flex">
                <div class="col-2 text-center full-left d-inline-flex justify-content-center align-items-center">
                    <div class="circle font-weight-bold">3</div>
                </div>
                <div class="col-8">
                    <h5>{props.data.tgl_3}</h5>
                    <p>{props.data.judul_3}</p>
                </div>
            </div>
            <div class="row timeline">
                <div class="col-2">
                    <div class="corner top-right"></div>
                </div>
                <div class="col-8">
                    <hr/>
                </div>
                <div class="col-2">
                    <div class="corner left-bottom"></div>
                </div>
            </div>

            <div class="row align-items-center justify-content-end how-it-works d-flex">
                <div class="col-8 text-right">
                    <h5>{props.data.tgl_4}</h5>
                    <p>{props.data.judul_4}</p>
                </div>
                <div class="col-2 text-center full-right d-inline-flex justify-content-center align-items-center">
                    <div class="circle font-weight-bold">4</div>
                </div>
            </div>
            <div class="row timeline">
                <div class="col-2">
                    <div class="corner right-bottom"></div>
                </div>
                <div class="col-8">
                    <hr/>
                </div>
                <div class="col-2">
                    <div class="corner top-left"></div>
                </div>
            </div>
            
            <div class="row align-items-center how-it-works d-flex">
                <div class="col-2 text-center full-left d-inline-flex justify-content-center align-items-center">
                    <div class="circle font-weight-bold">5</div>
                </div>
                <div class="col-8">
                    <h5>{props.data.tgl_5}</h5>
                    <p>{props.data.judul_5}</p>
                </div>
            </div>
            <div class="row timeline">
                <div class="col-2">
                    <div class="corner top-right"></div>
                </div>
                <div class="col-8">
                    <hr/>
                </div>
                <div class="col-2">
                    <div class="corner left-bottom"></div>
                </div>
            </div>

            <div class="row align-items-center justify-content-end how-it-works d-flex">
                <div class="col-8 text-right">
                    <h5>{props.data.tgl_6}</h5>
                    <p>{props.data.judul_6}</p>
                </div>
                <div class="col-2 text-center full-right d-inline-flex justify-content-center align-items-center">
                    <div class="circle font-weight-bold">6</div>
                </div>
            </div>
            <div class="row timeline">
                <div class="col-2">
                    <div class="corner right-bottom"></div>
                </div>
                <div class="col-8">
                    <hr/>
                </div>
                <div class="col-2">
                    <div class="corner top-left"></div>
                </div>
            </div>
            
            <div class="row align-items-center how-it-works d-flex">
                <div class="col-2 text-center full-left d-inline-flex justify-content-center align-items-center">
                    <div class="circle font-weight-bold">7</div>
                </div>
                <div class="col-8">
                    <h5>{props.data.tgl_7}</h5>
                    <p>{props.data.judul_7}</p>
                </div>
            </div>
            <div class="row timeline">
                <div class="col-2">
                    <div class="corner top-right"></div>
                </div>
                <div class="col-8">
                    <hr/>
                </div>
                <div class="col-2">
                    <div class="corner left-bottom"></div>
                </div>
            </div>
            
            <div class="row align-items-center justify-content-end how-it-works d-flex">
                <div class="col-8 text-right">
                    <h5>{props.data.tgl_8}</h5>
                    <p>{props.data.judul_8}</p>
                </div>
                <div class="col-2 text-center top d-inline-flex justify-content-center align-items-center">
                    <div class="circle font-weight-bold">8</div>
                </div>
            </div>
        </div>
    );
}

export default Timeline;